/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import img1 from '../assets/hero/hero_img.jpg'
import img2 from '../assets/hero/hero_img2.jpg'
import imgbg from '../assets/hero/h1_hero.jpg'
import Skeleton from 'react-loading-skeleton'

const HomeComponent = () => {
  const [dataYoutube, setDataYoutube] = useState()
  const keyApi = `AIzaSyCQGCRxR2HjvLrxiwHR2vRYFwoOL3dpfUY`
  const channelId = `UCYjhMXDnujBM4Gz_E0jzUDg`
  const result = 4

  var finalUrl = `https://youtube.googleapis.com/youtube/v3/activities?key=${keyApi}&channelId=${channelId}&part=snippet&maxResults=${result}`

  // Data Youtube
  const fetchData = async () => {
    try {
      const fetchApi = await fetch(`${finalUrl}`, {
        method: 'GET',
      })
      const dataApi = await fetchApi.json()
      console.log(dataApi.items)
      setDataYoutube(dataApi.items)
    } catch (error) {
      console.log('error')
      alert(error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <main>
      {/* slider Area Start*/}
      <div className="slider-area slider-height" data-background={imgbg}>
        <div className="slider-active">
          {/* Single Slider */}
          <div className="single-slider">
            <div className="slider-cap-wrapper">
              <div className="hero__img">
                <img
                  src={img1}
                  alt="image1"
                  data-animation="fadeInRight"
                  data-transition-duration="5s"
                />
              </div>
              <div className="hero__caption">
                <h1 data-animation="fadeInLeft" data-delay=".4s">
                  Selamat Datang Di
                  <br />
                  <span style={{ color: '#ed8c3e' }}>Eggless</span>
                </h1>
                <p data-animation="fadeInLeft" data-delay=".6s">
                  Masih bingung tentang kami dan ingin kenal lebih jauh dengan
                  kami? silahkan lihat tentang kami.
                </p>
                {/* Hero Btn */}
                <a
                  href="/about"
                  className="hero-btn"
                  data-animation="fadeInLeft"
                  data-delay=".9s"
                >
                  Ke About Page
                  {/* Arrow SVG icon */}
                  <svg
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512 512"
                    style={{ enableBackground: 'new 0 0 512 512' }}
                    xmlSpace="preserve"
                  >
                    <path
                      d="M506.134,241.843c-0.006-0.006-0.011-0.013-0.018-0.019l-104.504-104c-7.829-7.791-20.492-7.762-28.285,0.068
                                     c-7.792,7.829-7.762,20.492,0.067,28.284L443.558,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h423.557
                                     l-70.162,69.824c-7.829,7.792-7.859,20.455-0.067,28.284c7.793,7.831,20.457,7.858,28.285,0.068l104.504-104
                                     c0.006-0.006,0.011-0.013,0.018-0.019C513.968,262.339,513.943,249.635,506.134,241.843z"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          {/* Single Slider */}
          <div className="single-slider">
            <div className="slider-cap-wrapper">
              <div className="hero__img">
                <img
                  src={img2}
                  alt="image2"
                  data-animation="fadeInRight"
                  data-transition-duration="5s"
                />
              </div>
              <div className="hero__caption">
                <h1 data-animation="fadeInLeft" data-delay=".4s">
                  Ayo bangun bisnis anda
                  <br />
                  dengan <span style={{ color: '#ed8c3e' }}>Eggless</span>.
                </h1>
                <p data-animation="fadeInLeft" data-delay=".6s">
                  Anda dapat menekan tombol dibawah untuk menghubungi kami
                  langsung melalui whastapp. tunggu apalagi? segera hubungi
                  kami!
                </p>
                {/* Hero Btn */}
                <a
                  href="https://wa.me/6282111908780"
                  className="hero-btn"
                  data-animation="fadeInLeft"
                  data-delay=".9s"
                >
                  Link to whastapp
                  {/* Arrow SVG icon */}
                  <svg
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512 512"
                    style={{ enableBackground: 'new 0 0 512 512' }}
                    xmlSpace="preserve"
                  >
                    <path
                      d="M506.134,241.843c-0.006-0.006-0.011-0.013-0.018-0.019l-104.504-104c-7.829-7.791-20.492-7.762-28.285,0.068
                                     c-7.792,7.829-7.762,20.492,0.067,28.284L443.558,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h423.557
                                     l-70.162,69.824c-7.829,7.792-7.859,20.455-0.067,28.284c7.793,7.831,20.457,7.858,28.285,0.068l104.504-104
                                     c0.006-0.006,0.011-0.013,0.018-0.019C513.968,262.339,513.943,249.635,506.134,241.843z"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* slider Area End*/}
      {/* Want To Work Start */}
      <div className="wantToWork-area w-padding">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-xl-5 col-lg-7 col-md-8">
              <div className="wantToWork-caption">
                <p>
                  Services apa saja yang{' '}
                  <span style={{ color: '#ed8c3e', fontWeight: 'bold' }}>
                    eggless
                  </span>{' '}
                  sediakan?
                </p>
                <h2>Dibawah ini adalah sedikit services yang kami berikan.</h2>
              </div>
            </div>
            <div className="col-xl-7 col-lg-5 col-md-4">
              <div className="wantToWork-btn f-right">
                <a href="/service" className="btn btn-ans">
                  view more
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Want To Work End */}
      {/* Our Services Start */}
      <div className="our-services  pt-50 pb-150">
        <div className="container">
          <div className="row">
            <div className=" col-lg-4 col-md-6 col-sm-6">
              <div className="single-services text-center mb-30">
                <div className="services-ion">
                  <span className="fas fa-globe" />
                </div>
                <div className="services-cap mt-4">
                  <h5>Web Developer</h5>
                  <p>
                    Adalah Pengembang Web yang bekerja untuk merancang, membuat,
                    dan memelihara situs web dan aplikasi web.
                  </p>
                </div>
              </div>
            </div>
            <div className=" col-lg-4 col-md-6 col-sm-6">
              <div className="single-services text-center mb-30">
                <div className="services-ion">
                  <span className="fas fa-mobile-alt" />
                </div>
                <div className="services-cap mt-4">
                  <h5>Mobile Developer</h5>
                  <p>
                    Merupakan seorang programmer yang bisa membuat sebuah produk
                    berupa aplikasi dan dapat di tambahkan ke playstore.
                  </p>
                </div>
              </div>
            </div>
            <div className=" col-lg-4 col-md-6 col-sm-6">
              <div className="single-services text-center mb-30">
                <div className="services-ion">
                  <span className="fas fa-pencil-ruler" />
                </div>
                <div className="services-cap mt-4">
                  <h5>Design Ui / Ux</h5>
                  <p>
                    UI Designer memiliki tugas menentukan tampilan situs & UX
                    Designer menentukan bagaimana suatu situs bisa beroperasi.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Our Services End */}
      {/* Want To Work Start */}
      <div className="wantToWork-area w-padding" style={{ marginTop: '-10%' }}>
        <div className="container">
          <div className="row align-items-end">
            <div className="col-xl-5 col-lg-7 col-md-8">
              <div className="wantToWork-caption">
                <p>
                  Project apa aja yang pernah{' '}
                  <span style={{ color: '#ed8c3e', fontWeight: 'bold' }}>
                    eggless
                  </span>{' '}
                  buat?
                </p>
                <h2> Project yang sudah pernah kami kerjakan.</h2>
              </div>
            </div>
            <div className="col-xl-7 col-lg-5 col-md-4">
              <div className="wantToWork-btn f-right">
                <a href="/work" className="btn btn-ans">
                  view more
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Want To Work End */}
      {/* Project Gallery Start */}
      <div className="project-gallery-area">
        <div className="container-full p-0">
          <div className="row no-gutters">
            {/* Big img */}
            <div className="col-lg-5 col-md-4">
              <div className="portfolio-wrapper">
                <div
                  className="portfolio-thumb big-img"
                  style={{
                    backgroundImage: 'url(/assets/images/portofolio1.png)',
                    backgroundSize: 'cover',
                  }}
                ></div>
                {/* Popup img Link */}
                <div className="portfolio-content">
                  <a href="https://dribbble.com/shots/15339320-Muslim-News">
                    Know more about{' '}
                    <span style={{ fontWeight: 'bold' }}>ARMAN.</span>
                  </a>
                </div>
              </div>
            </div>
            {/* Small Img */}
            <div className="col-lg-7 col-md-8">
              <div className="row no-gutters">
                <div className="col-lg-5 col-md-6 col-sm-6">
                  <div className="portfolio-wrapper">
                    <div
                      className="portfolio-thumb small-img"
                      style={{
                        backgroundImage: 'url(assets/images/portofolio2.png)',
                        backgroundSize: 'cover',
                      }}
                    ></div>
                    {/* Popup img Link */}
                    <div className="portfolio-content">
                      <a href="https://dribbble.com/shots/15327478-Dashboard-Point-of-Sales">
                        Know more about{' '}
                        <span style={{ fontWeight: 'bold' }}>POS.</span>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 col-md-6 col-sm-6">
                  <div className="portfolio-wrapper">
                    <div
                      className="portfolio-thumb small-img"
                      style={{
                        backgroundImage: 'url(assets/images/portofolio3.png)',
                        backgroundSize: 'cover',
                      }}
                    ></div>
                    {/* Popup img Link */}
                    <div className="portfolio-content">
                      <a href="https://dribbble.com/shots/15290366-Game-App">
                        Know more about{' '}
                        <span style={{ fontWeight: 'bold' }}>Game App.</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row no-gutters">
                <div className="col-lg-7 col-md-6 col-sm-6">
                  <div className="portfolio-wrapper">
                    <div
                      className="portfolio-thumb small-img"
                      style={{
                        backgroundImage: 'url(assets/images/portofolio4.png)',
                        backgroundSize: 'cover',
                      }}
                    />
                    {/* Popup img Link */}
                    <div className="portfolio-content">
                      <a href="https://dribbble.com/shots/15445827-Healthis-Splash-Screen">
                        Know more about{' '}
                        <span style={{ fontWeight: 'bold' }}>HEALTHIS.</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Project Gallery End */}
      {/* Want To Work Start */}
      <div className="wantToWork-area w-padding3">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-xl-5 col-lg-7 col-md-8">
              <div className="wantToWork-caption">
                <p>Mari lihat konten eggless</p>
                <h2>Konten kami yang ada di youtube.</h2>
              </div>
            </div>
            <div className="col-xl-7 col-lg-5 col-md-4">
              <div className="wantToWork-btn f-right">
                <a
                  href="https://www.youtube.com/channel/UCYjhMXDnujBM4Gz_E0jzUDg"
                  className="btn btn-ans"
                >
                  view more
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Want To Work End */}
      {/* David Droga start */}
      <div className="david-droga-area  pb-160">
        <div className="container">
          <div className="row">
            {dataYoutube ? (
              dataYoutube.map((item) => {
                const date = new Date(item.snippet.publishedAt)
                console.log(date.get)
                return (
                  <div className="col-xl-6 col-lg-6 col-md-6">
                    {/* single-david */}
                    <div className="single-david mb-30">
                      <div className="david-img">
                        <img
                          src={item.snippet.thumbnails.high.url}
                          alt={item.snippet.thumbnails.high.url}
                        />
                      </div>
                      <div className="david-captoin">
                        <h2>
                          <a href="#">{item.snippet.title}</a>
                        </h2>
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (
              <div className="col-xl-6 col-lg-6 col-md-6">
                {/* single-david */}
                <div className="single-david mb-30">
                  <div className="david-img">
                    <Skeleton />
                  </div>
                  <div className="david-captoin">
                    <ul className="david-info">
                      <li>
                        <Skeleton />
                      </li>
                    </ul>
                    <h2>
                      <a href="#">
                        <Skeleton />
                      </a>
                    </h2>
                    <span>
                      <Skeleton />
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* David Droga End */}
      {/* Want To Work Start */}
      <div className="wantToWork-area wantToWork-area2 w-padding2">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-xl-8 col-lg-8 col-md-8">
              <div className="wantToWork-caption wantToWork-caption2">
                <h2>
                  Segera hubungi kami dan buat bisnis anda menjadi digital
                  dengan kami.
                </h2>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4">
              <a href="/contact" className="btn btn-black f-right">
                contact us now
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Want To Work End */}
    </main>
  )
}

export default HomeComponent
